module.exports = __webpack_public_path__ + "img/2x.81bfb7a.jpg";